import { render, staticRenderFns } from "./ProfitCreate.vue?vue&type=template&id=7b4510c4&scoped=true&"
import script from "./ProfitCreate.vue?vue&type=script&lang=js&"
export * from "./ProfitCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProfitCreate.vue?vue&type=style&index=0&id=7b4510c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4510c4",
  null
  
)

export default component.exports